<template>
  <div>
    <div>
      <b-container fluid class="p-2">
        <b-row>
          <b-col>
            <b-container fluid class="m-0 p-0">
              <b-row>
                <b-col
                  cols="auto"
                  v-for="item in filterList"
                  :key="item.metricName"
                  @click="commitSelectedItem(item.metadata, item)"
                >
                  <IndexFilterChip
                    :id="item.id"
                    :description="item.description"
                    :metric="item.metric"
                    :metric-name="item.metricName"
                    :selectedItem="selectedItem"
                  > </IndexFilterChip>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
  // *****************************************************************************************************************
  //                                                  IMPORTS
  // *****************************************************************************************************************
  import { GeneralUtils, DimensionUtils, FilterObjectParameterBuilder } from '@/mixins/index'
  import IndexFilterChip from './IndexFilterChip'

  export default {
    name: 'IndexFilter',
    // *****************************************************************************************************************
    //                                                 MIXINS
    // *****************************************************************************************************************
    mixins: [GeneralUtils, DimensionUtils, FilterObjectParameterBuilder],
    // *****************************************************************************************************************
    //                                                  PROPS
    // *****************************************************************************************************************
    props: ['filterList'],
    // *****************************************************************************************************************
    //                                                  COMPONENTS
    // *****************************************************************************************************************
    components: {
      IndexFilterChip
    },
    data () {
      return {
        dynClass: 'bg-light',
        selectedItem: 0
      }
    },
    // *****************************************************************************************************************
    //                                                HOOKS
    // *****************************************************************************************************************
    created () {
    },
    watch: {
      filterList (item) {
        this.setFirstItem(item)
      }
    },
    computed: {
      vuexSelectedReport () {
        return this.$store.state.generalKeyKpiAnalysis.selectedReport
      },
      vuexFilterObjectActiveInstance () {
        return this.$_generalUtils_deepJsonCopy(this.$store.state.filterRequestObject.activeFilterObjectInstance)
      },
      vuexSelectedRetail () {
        return this.$store.state.generalKeyKpiAnalysis.selectedRetail
      }
    },
    // *****************************************************************************************************************
    //                                                METHODS
    // *****************************************************************************************************************
    methods: {
      // ********************************************** VUEX COMMITS ***************************************************
      setFirstItem (item) {
        this.$store.commit('commit_dimensionFilterQuickAccess_selectedIndexItem', item[0])
      },
      commitSelectedItem (itemMetaData, item) {
        this.$store.commit('commit_dimensionFilterQuickAccess_selectedIndexItem', item)
        this.$eventHub.$emit('index-filter-new-selection')
        this.$root.$emit('bv::toggle::collapse', 'dim-filter-index-collapse')
      },
      commitRequestParameters (parameters) {
        this.$store.commit('commit_gridMetricSystemWideOneMetric_requestParams',
          this.$_generalUtils_deepJsonCopy(parameters))
        this.$eventHub.$emit('grid-metric-wide-one-metric-fetch-data')
      }
      // ********************************************** REQUESTS *******************************************************
    }
  }
</script>


<style scoped>
  .plus-icon {
    position: absolute;
    bottom: 0;
    right: 13px;
    margin-bottom: 7px;
    color: #00aced;
  }

</style>



// WEBPACK FOOTER //
// src/expertoRetail/components/DimensionFilterQuickAccess/IndexFilter.vue